import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-51da3871")
const _hoisted_1 = ["type", "placeholder", "readonly", "value", "max", "min"]
const _hoisted_2 = {
  key: 1,
  class: "text-field"
}
const _hoisted_3 = ["type", "placeholder", "value", "readonly"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "ri-file-copy-line ri-xl" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "copied-msg" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.showCopyBtn)
    ? (_openBlock(), _createElementBlock("input", {
        key: 0,
        ref: "inputRef",
        type: _ctx.type,
        placeholder: _ctx.placeholder,
        readonly: _ctx.readonly,
        value: _ctx.value,
        max: _ctx.max,
        min: _ctx.min,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:inputVal', $event.target.value)))
      }, null, 40, _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("input", {
          ref: "inputRef",
          style: {"padding-right":"40px"},
          type: _ctx.type,
          placeholder: _ctx.placeholder,
          value: _ctx.value,
          readonly: _ctx.readonly,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:inputVal', $event.target.value)))
        }, null, 40, _hoisted_3),
        _createElementVNode("span", {
          class: "copy-btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.writeToClipboard(_ctx.value)))
        }, _hoisted_5),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("span", _hoisted_6, " コピーしました ", 512), [
              [_vShow, _ctx.showCopiedMsg]
            ])
          ]),
          _: 1
        })
      ]))
}